<template></template>

<script>
import Vue from "vue";
import icForm from "@/ic-common/mixins/icForm";

export default {
  name: "IcFormContactBase",
  mixins: [icForm],
  data() {
    return {
      form: {
        type: "base",
        email: "",
        message: "",
        agreement: "",
//        recaptcha: ""
      },

      formUrl: "/ax26hrxl857-a/components/icforms/connector.php?action=store"
    };
  },

  components: {}
};
</script>

<style>
</style>
